import React from 'react';

const Services = () => {
  return (
    <section id="services" className="py-16 bg-neutral-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-neutral-900">Our Services</h2>
        <p className="text-center text-neutral-600 mb-12 max-w-2xl mx-auto">
          Comprehensive FASTag solutions for both business partners and individual customers
        </p>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition">
            <div className="flex items-center mb-6">
              <div className="bg-primary-100 p-3 rounded-lg mr-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-neutral-900">B2B Services</h3>
            </div>
            <p className="text-neutral-700 mb-6 font-semibold">For Agents & Channel Partners</p>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg className="w-6 h-6 text-secondary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-700"><strong>Authorized Bank Agent IDs:</strong> Official onboarding and instant Agent ID issuance for SBI and IDFC First Bank</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-secondary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-700"><strong>Bulk Inventory Supply:</strong> Direct access to genuine FASTag inventory at competitive partner rates</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-secondary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-700"><strong>24/7 Query Resolution:</strong> Round-the-clock backend support for tag blacklisting, portal glitches, KYC issues</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-secondary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-700"><strong>Agent Portal Support:</strong> End-to-end guidance on navigating bank portals and tracking commissions</span>
              </li>
            </ul>
            <a href="#agent-form" className="mt-8 block w-full bg-primary text-white text-center py-3 rounded-lg font-semibold hover:bg-primary-700 transition">
              Become an Agent
            </a>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition">
            <div className="flex items-center mb-6">
              <div className="bg-secondary-100 p-3 rounded-lg mr-4">
                <svg className="w-8 h-8 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-neutral-900">B2C Services</h3>
            </div>
            <p className="text-neutral-700 mb-6 font-semibold">For Direct Customers</p>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg className="w-6 h-6 text-secondary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-700"><strong>Online FASTag Registration:</strong> Simple, paperless online registration for personal and commercial vehicles</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-secondary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-700"><strong>Doorstep FASTag Delivery:</strong> Express home delivery of physical tags, ready for immediate activation</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-secondary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-700"><strong>Customer Helpdesk:</strong> Continuous support for toll deduction errors, tag replacements, balance queries</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-secondary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-700"><strong>Bank Re-issuances:</strong> Hassle-free tag replacement and reissuance services</span>
              </li>
            </ul>
            <a href="#customer-form" className="mt-8 block w-full bg-secondary text-white text-center py-3 rounded-lg font-semibold hover:bg-secondary-700 transition">
              Get Your FASTag
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
